Login As ...
<ul>
  <li *ngFor="let user of users" (click)="loginAs(user)" role="button">{{ user.name }}</li>
</ul>



// WEBPACK FOOTER //
// ./src/app/auth/login-as/login-as.component.html